import { takeLatest } from 'redux-saga/effects';

import { ExampleGalleryActions, exampleIdString } from '../../constants';

// Save the example id to local storage
function* setExampleIdToLocalStorage(action) {
  if (window.localStorage) {
    if (action.exampleId) {
      yield localStorage.setItem(exampleIdString, action.exampleId);
    }
  }
}

// This saga handles changes to the dashboard selection popup
export default function* exampleGallerySaga() {
  yield takeLatest(ExampleGalleryActions.SET_LINKED_EXAMPLE, setExampleIdToLocalStorage);
}
